module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"required":"required"},"fr":{"required":"requis"},"es":{"required":"obligatorio"},"pt":{"required":"obrigatório"},"ar":{"required":"مطلوب"},"sv":{"required":"obligatorisk"},"fi":{"required":"pakollinen"},"ja":{"required":"必須"}}')
  delete Component.options._Ctor
}
